import { Injectable } from "@angular/core";
// router store
import { DistrictsService, SchoolsService, TeachersService, UsersFidoService } from "@carnegie-learning/data-access-angular-passport";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { of } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";
import * as schoolsActions from "../actions/schools.action";

@Injectable()
export class SchoolsEffects {
    constructor(
        private actions$: Actions,
        private districtsService: DistrictsService,
        private schoolsService: SchoolsService,
        private usersFidoService: UsersFidoService,
        private teachersService: TeachersService
    ) {}

    loadSchools$ = createEffect(() =>
        this.actions$.pipe(
            ofType(schoolsActions.loadDistrictSchools),
            map((action) => action.districtID),
            switchMap((districtID) => {
                return this.districtsService
                    .getDistrictSchools(districtID)
                    .pipe(
                        // mapping over all the districts and returning an action
                        map((schools) => schools),
                        map((response) =>
                            schoolsActions.loadSchoolsSuccess({
                                payload: response,
                            })
                        ),
                        // need to wrap the error in 'of' so it becomes an observable action
                        catchError((error) =>
                            of(
                                schoolsActions.loadSchoolsFail({
                                    payload: error,
                                })
                            )
                        )
                    );
            })
        )
    );
    loadTeacherSchools$ = createEffect(() =>
        this.actions$.pipe(
            ofType(schoolsActions.loadTeacherSchools),
            map((action) => action.teacherID),
            switchMap((teacherID) => {
                return this.teachersService.getTeacherSchools(teacherID).pipe(
                    // mapping over all the districts and returning an action
                    map((schools) => schools),
                    map((response) =>
                        schoolsActions.loadTeacherSchoolsSuccess({
                            payload: response,
                        })
                    ),
                    // need to wrap the error in 'of' so it becomes an observable action
                    catchError((error) =>
                        of(schoolsActions.loadSchoolsFail({ payload: error }))
                    )
                );
            })
        )
    );
    loadSchool$ = createEffect(() =>
        this.actions$.pipe(
            ofType(schoolsActions.loadCoursesSchool),
            // gets router params (in this case the districtID)
            // and sends it with service call
            map((action) => action.schoolID),
            switchMap((schoolID) => {
                return this.schoolsService.getSchoolsViaSearch([schoolID]).pipe(
                    // mapping over all the districts and returning an action
                    map((response) =>
                        schoolsActions.loadCoursesSchoolSuccess({
                            payload: response,
                        })
                    ),
                    // need to wrap the error in 'of' so it becomes an observable action
                    catchError((error) =>
                        of(
                            schoolsActions.loadCoursesSchoolFail({
                                payload: error,
                            })
                        )
                    )
                );
            })
        )
    );

    loadSchoolFidoStudents$ = createEffect(() =>
        this.actions$.pipe(
            ofType(schoolsActions.loadSchoolFidoStudents),
            switchMap(({ schoolID, pagingparameter }) =>
                this.usersFidoService
                    .getSchoolStudents(schoolID, pagingparameter)
                    .pipe(
                        switchMap((res) => {
                            if (
                                res.pagingparameter &&
                                res.pagingparameter !== "NO_MORE" &&
                                !(<any>window).isDemo
                            ) {
                                return [
                                    schoolsActions.loadSchoolFidoStudentsSuccess(
                                        { res }
                                    ),
                                    schoolsActions.loadSchoolFidoStudents({
                                        schoolID,
                                        pagingparameter: res.pagingparameter,
                                    }),
                                ];
                            }
                            return [
                                schoolsActions.loadSchoolFidoStudentsSuccess({
                                    res,
                                }),
                            ];
                        }),
                        catchError((error) =>
                            of(
                                schoolsActions.loadSchoolFidoStudentsFail({
                                    payload: error,
                                })
                            )
                        )
                    )
            )
        )
    );
}
